import React from 'react';
import { Link } from 'react-router-dom';
import './Rugs.css';
import rugImage1 from '../assets/rug1.png';
import rugImage2 from '../assets/rug2.png';
import rugImage3 from '../assets/rug3.png';
import rugImage4 from '../assets/rug4.png';

const Rugs = () => {
  return (
    <div className="rugs-container">
      <h1 className="page-title">Rugs Intervention</h1>
      
      <div className="content-section">
        <p>
          Our project is in Bodh Gaya, a sacred religious site located in the Gaya district of Bihar. 
          Bodh Gaya is famous as the place where Gautama Buddha attained enlightenment under the Bodhi Tree, 
          making it an important destination for pilgrims and tourists from around the world. Many monks come 
          here to practice yoga and meditation, so we decided to make specialized yoga and meditation rugs 
          that symbolize the spiritual essence of Bodh Gaya.
        </p>
      </div>

      {/* Unified Image Grid */}
      <div className="rugs-grid">
        <div className="grid-item">
          <img src={rugImage1} alt="Traditional rug design" className="rug-image" />
          {/* <p className="image-caption">Traditional Bodh Gaya patterns</p> */}
        </div>
        <div className="grid-item">
          <img src={rugImage2} alt="Artisan working on rug" className="rug-image" />
          {/* <p className="image-caption">Skilled artisans at work</p> */}
        </div>
        <div className="grid-item">
          <img src={rugImage3} alt="Colorful rug patterns" className="rug-image" />
          {/* <p className="image-caption">Vibrant color combinations</p> */}
        </div>
        <div className="grid-item">
          <img src={rugImage4} alt="Women weaving rugs" className="rug-image" />
          {/* <p className="image-caption">Women empowerment through craft</p> */}
        </div>
      </div>

      <div className="content-section">
        <p>
          These rugs serve many purposes—yoga, exercise, meditation, puja, and sitting—offering visitors 
          not just a product, but a meaningful connection to the place. By purchasing these rugs, visitors 
          are supporting local artisans and taking home a piece of Bodh Gaya's cultural and spiritual heritage.
        </p>
        
        <h2>Modernizing Traditional Crafts</h2>
        <p>
          We are working on a special project that focuses on creating rugs by our skilled women artisans. 
          Traditionally, these artisans have been following the same design patterns for years. However, 
          through our School of Design, we are teaching them new and creative ideas, introducing fresh 
          patterns that not only bring a modern touch to their work but also make the products more appealing 
          to the current market.
        </p>
        
        <h2>Cultural Significance</h2>
        <p>
          Rugs are an important part of Indian culture, serving both as decorative pieces and practical items 
          with a long history. Traditionally made by skilled artisans using old techniques, rugs have been a 
          part of Indian homes for generations, providing comfort and warmth while also reflecting the culture 
          and traditions of the local area.
        </p>
        
        <h2>Our Projects</h2>
        <p>
          The BAL JYOTI FOUNDATION stepped in to help local communities by training people in rug weaving. 
          Our projects in Peshrar (Jharkhand) and Bodhgaya (Bihar) focus on empowering local women artisans, 
          providing them with skills and resources to create high-quality, handcrafted rugs while preserving 
          traditional craftsmanship.
        </p>
      </div>

      <div className="navigation-buttons">
        <Link to="/intervention/bamboo" className="nav-button">
          <span className="button-icon">→</span> Bamboo Crafts
        </Link>
        <Link to="/intervention/basketry" className="nav-button">
          <span className="button-icon">→</span> Basketry Arts
        </Link>
        <Link to="/intervention/stitching" className="nav-button">
          <span className="button-icon">→</span> Stitching Traditions
        </Link>
      </div>
    </div>
  );
}

export default Rugs;